import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'

const dtWeighingCombinerTicketsConfig = dtConfig[ModulesMap.WEIGHING_COMBINER_TICKETS]

function getWeighingCombinerTickets(companyId, query) {
	return dataTransferWrap(
		ModulesMap.WEIGHING_COMBINER_TICKETS,
		dtWeighingCombinerTicketsConfig[ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKETS],
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		},
	)
}
function getWeighingCombinerTicket(companyId, combinerTicketId) {
	return dataTransferWrap(
		ModulesMap.WEIGHING_COMBINER_TICKETS,
		dtWeighingCombinerTicketsConfig[ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKET],
		{
			urlParams: {
				companyId: companyId,
				combinerTicketId,
			},
		},
	)
}
function getWeighingCombinerTicketPreview(companyId, combinerTicketId) {
	return dataTransferWrap(
		ModulesMap.WEIGHING_COMBINER_TICKETS,
		dtWeighingCombinerTicketsConfig[ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKET_PREVIEW],
		{
			urlParams: {
				companyId: companyId,
				combinerTicketId,
			},
		},
	)
}

export default {
	getWeighingCombinerTickets,
	getWeighingCombinerTicket,
	getWeighingCombinerTicketPreview,
}
